/* eslint-disable */
import React, { useEffect, useState, useContext } from 'react'
import HeaderSearch from './HeaderSearch'
import './Header.css'
import axios from 'axios'
import { Link, NavLink, useHistory, useLocation } from 'react-router-dom'
import { Button, Popover, ListItem, Divider, SwipeableDrawer, MenuItem } from '@material-ui/core'
import { handleRedirectInternal } from '../../../Product/common/components'
import AuthContext from '../../../Product/context/auth/authContext'
import AlertContext from '../../../Product/context/alert/alertContext'
import { useMediaQuery } from 'react-responsive'
import { Logo } from '../../../utils/index'
import PrimaryButton from '../../../Product/components/atoms/PrimaryButton'
import BecomeSeller from '../../../utils/CommonFunctionality/BecomeSeller'
import CustomDialog from '../../../Product/components/organisms/Dialog'
import CartIcon from '../../../utils/CommonFunctionality/Cart/CartIcon'
import ProductContext from '../../../Product/context/product/productContext'
import Timer from '../../../Product/common/timer'
import StripeCardContext from '../../../Product/context/stripe/card/cardContext'
import DirectStripeContext from '../../../Product/context/directStripe/directStripeContext'
import Headernavmenu from '../../../utils/CommonFunctionality/HeaderNavigaton/headernavigation'
import { Swiper, SwiperSlide, useSwiper, useSwiperSlide } from 'swiper/react/swiper-react'
import 'swiper/swiper-bundle.css'
import { EffectCoverflow, Navigation, Autoplay, Pagination } from 'swiper'
import UserContext from '../../../Product/context/user/userContext'
import pluginContext from '../../../Product/context/plugin/pluginContext'
import Dialog from '@material-ui/core/Dialog'
import Slide from '@material-ui/core/Slide'
import SecondaryButton from '../../../Product/components/atoms/SecondaryButton'
import { socket, socketAuction } from '../../../Product/common/socket'
import Popup from '../../../Product/components/organisms/Popup'
import AllProducts from '../../../Component/MyBids/AllProducts'
import schedulePickupContext from '../../../Product/context/plugin/schedulePickup/schedulePickupContext'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="bottom" ref={ref} {...props} />
})

const Header = (props) => {
    const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent)
    const location = useLocation()
    const [filterValues, setFilterValues] = useState([])
    const history = useHistory()
    const [anchormenu, setanchormenu] = useState(null)
    const [catAnchormenu, setCatAnchormenu] = useState(null)
    const [dealAnchormenu, setDealAnchormenu] = useState(null)
    const [auctionMenu, setAuctionMenu] = useState(null)
    const [open, setOpen] = useState(false)
    const { responseStatus: pluginstatus, clearResponse: clearpluginresponse } =
        useContext(pluginContext)
    const {
        user,
        isAuthenticated,
        logout,
        userCount,
        loadUser,
        responseStatus: responseStatusUser,
        clearResponse: clearResponseUser,
    } = useContext(AuthContext)
    const productContext = useContext(ProductContext)
    const userContext = useContext(UserContext)
    const { get_all_card_details } = useContext(StripeCardContext)
    const { usercards } = useContext(DirectStripeContext)
    const [cards, setCards] = useState([{}])
    const {
        search_allauctions,
        getAllSearchAuctions,

        productLocalState,
        search_allproducts,
        getAllSearchProducts,
        setState: setProductState,
    } = productContext

    const { responseStatus: responseStatusSchedule, clearResponse: clearResponseSchedule } =
        useContext(schedulePickupContext)
    const {
        getLocation,
        termsCheckUpdate,
        responseStatus,
        unpickedItemsCount,
        setUnpickedItemsCount,
    } = userContext

    const [viewAuction, setViewAuction] = useState([])
    const [viewCategories, setViewCategories] = useState([])
    const [termsDialog, setTermsDialog] = useState(false)
    const [termsCheck, setTermsCheck] = useState(false)
    const [scheduleLoading, setScheduleLoading] = useState(false)
    const [unpickedItems, setUnpickedItems] = useState(false)
    const [openMultiplePickup, setOpenMultiplePickup] = useState(false)
    const [sublotSearch, setSublotSearch] = useState({
        page: 1,
        sh_limit: sessionStorage.getItem('sh_limit'),
        searchbar: '',
        orderby: global?.storeConfigration?.liquidation_filter_update?.value == 1 ? '15' : '',
        location: [],
        sortType: global?.storeConfigration?.liquidation_filter_update?.value == 1 ? 2 : undefined,
        state: [],
        city: [],
    })
    const [auctionSearch, setAuctionSearch] = useState({
        page: 1,
        sh_limit: '10',
        orderby: '2',
        searchbar: '',
        auc_type: '',
        type: '',
        orderby2: global?.storeConfigration?.liquidation_filter_update?.value == 1 ? '' : '6',
        need_bid_increment: 1,
        auction_city: [],
        auction_state: [],
        special_events: [],
    })

    const { setAlert } = useContext(AlertContext)
    const isDesktop = useMediaQuery({
        query: '(min-width: 991px)',
    })
    const [state, setState] = useState({
        top: false,
        right: false,
        left: false,
    })

    const [locationDialog, setLocationDialog] = useState(false)
    const [btnLoading, setBtnLoading] = useState(false)
    const [currentLocation, setCurrentLocation] = useState('San Antonio')
    useEffect(() => {
        if (window.location.hostname === 'localhost') {
            axios.defaults.headers.common['domain'] = 'auction_preview.ecommerce.auction'
        }
    }, [])

    useEffect(() => {
        if (user) {
            setTermsDialog(user?.terms_check ? false : true)
        }
    }, [user])
    useEffect(() => {
        if (responseStatusSchedule) {
            if (responseStatusSchedule.from === 'addSchedule') {
                if (responseStatusSchedule.status === 'success') {
                    setScheduleLoading(true)
                    loadUser()
                }
            }
            clearResponseSchedule()
        }
    }, [responseStatusSchedule])
    useEffect(() => {
        if (scheduleLoading) {
            if (user?.unpicked_paid_items > 0) {
                setUnpickedItems(true)
                // localStorage.setItem('unpickedItemsBanner', user?.unpicked_paid_items && 0)
            } else {
                setUnpickedItems(false)
                // localStorage.setItem('unpickedItemsBanner', 0)
            }

            setOpenMultiplePickup(false)

            setScheduleLoading(false)
        }
    }, [user])
    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'termsCheckUpdate') {
                if (responseStatus.status === 'success') {
                    loadUser()
                    setTermsDialog(false)
                }
                setBtnLoading(false)
            }
        }
    }, [responseStatus])
    useEffect(() => {
        setFilterValues(
            global?.allCategories
                ?.filter((val) => val.level === 0)
                ?.sort((a, b) => a.description.localeCompare(b.description)),
        )
    }, [global.allCategories])

    useEffect(() => {
        if (!isDesktop) {
            getAllSearchAuctions(auctionSearch, 'activeHeader')
        }
    }, [auctionSearch])

    useEffect(() => {
        if (search_allauctions.from === 'activeHeader') {
            setViewAuction(search_allauctions.results.length ? search_allauctions.results : [])
        }
    }, [search_allauctions])

    useEffect(() => {
        if (search_allproducts.from === 'activeHeader') {
            setViewCategories(
                search_allproducts.maincategory.length ? search_allproducts.maincategory : [],
            )
        }
    }, [search_allproducts])

    useEffect(() => {
        socket.on('success_after_pay_auction_autoPay', (data) => {
            if (user?.id === parseInt(data.user_id)) {
                setUnpickedItemsCount(unpickedItemsCount + 1)
            }
        })

        socketAuction.on('success_after_pay_auction_autoPay', (data) => {
            if (user?.id === parseInt(data.user_id)) {
                setUnpickedItemsCount(unpickedItemsCount + 1)
            }
        })

        return () => {
            socket.off('success_after_pay_auction_autoPay', (data) => {
                if (user?.id === parseInt(data.user_id)) {
                    setUnpickedItemsCount(unpickedItemsCount + 1)
                }
            })

            socketAuction.on('success_after_pay_auction_autoPay', (data) => {
                if (user?.id === parseInt(data.user_id)) {
                    setUnpickedItemsCount(unpickedItemsCount + 1)
                }
            })
        }
    }, [])

    useEffect(() => {
        const unpickedItemsBanner = localStorage.getItem('unpickedItemsBanner')
        if (
            unpickedItemsBanner == null &&
            user?.unpicked_paid_items > 0 &&
            Number(user?.unpicked_paid_items) !== Number(unpickedItemsBanner)
        ) {
            // localStorage.setItem(
            //     'unpickedItemsBanner',
            //     user?.unpicked_paid_items > 0 ? user?.unpicked_paid_items : 0,
            // )
            setUnpickedItems(true)
        } else {
            // localStorage.setItem(
            //     'unpickedItemsBanner',
            //     user?.unpicked_paid_items > 0 ? user?.unpicked_paid_items : 0,
            // )
            setUnpickedItems(
                user?.unpicked_paid_items > 0 &&
                    Number(user?.unpicked_paid_items) !== Number(unpickedItemsBanner)
                    ? true
                    : false,
            )
        }
    }, [user?.id])

    useEffect(() => {
        const unpickedItemsBanner = localStorage.getItem('unpickedItemsBanner')
        if (
            (unpickedItemsCount != 0 || unpickedItemsCount == null) &&
            Number(user?.unpicked_paid_items) !== Number(unpickedItemsBanner)
        ) {
            // localStorage.setItem('unpickedItemsBanner', user?.unpicked_paid_items ?? 0)
            setUnpickedItems(true)
            setUnpickedItemsCount(0)
        }
    }, [unpickedItemsCount])

    useEffect(() => {
        if (!isDesktop) {
            getAllSearchProducts(sublotSearch, 'activeHeader')
        }
    }, [])

    const handleMenu = (event) => {
        setanchormenu(event.currentTarget)
    }

    const handleUnpickedItemsClose = () => {
        localStorage.setItem('unpickedItemsBanner', user?.unpicked_paid_items ?? 0)
        setUnpickedItems(false)
    }

    const handleMenuAuction = (event) => {
        if (!user.card_profileid) {
            setAlert('Kindly add account id to continue!', 'warning')
            return handleRedirectInternal(history, 'dashboard/profile')
        }
        setAuctionMenu(event.currentTarget)
    }
    const checkBeachThemeClassName = document.body.className == 'liquidationTwo beachLiquidation'
    const isBidAuctionTheme = document.body.classList[0] === 'BidAuction'
    const isBargainsAuctionTheme = document.body.className === 'BidAuction bargains'
    const isBidAuctionDepotTheme = document.body.className === 'BidAuction BidAuctionDepot'
    const handleClose = (history, path) => {
        setanchormenu(null)
        setAuctionMenu(null)
        if (history && path && path !== 'backdropClick') {
            handleRedirectInternal(history, path)
        }
    }
    const handleCatMenu = (event) => {
        setCatAnchormenu(event.currentTarget)
    }
    const handleDealsClose = () => {
        setDealAnchormenu(null)
    }
    const handleDealsMenu = (event) => {
        setDealAnchormenu(event.currentTarget)
    }
    const toggleOpen = () => {
        setOpen(!open)
    }
    const logoutUser = () => {
        localStorage.removeItem('unpickedItemsBanner')
        logout()
        if (window.location.href.includes(global?.storeDetails?.id)) {
            window.location.href = `/${global?.storeDetails?.id}/login`
        } else {
            window.location.href = '/login'
        }
    }

    const toggleDrawer = (anchor, open) => (event) => {
        setState({ ...state, [anchor]: open })
    }
    const handleCatClose = () => {
        setState({ ...state, right: false })
        setCatAnchormenu(null)
    }

    const handleCatCloseWithoutMenu = () => {
        setCatAnchormenu(null)
    }
    const handleClick = (catId) => {
        handleRedirectInternal(history, `search/product-buyer-auction/${catId}`)
    }

    const handleSellClick = (path) => {
        if (isAuthenticated) {
            if (!user?.card_profileid) {
                setAlert('Kindly add account id to continue!', 'warning')
                return handleRedirectInternal(history, 'dashboard/profile')
            } else if (user && user.role == 1) {
                return handleRedirectInternal(history, path)
            } else {
                return handleRedirectInternal(history, 'becomeSeller')
            }
        } else {
            return handleRedirectInternal(history, 'becomeSeller')
        }
    }

    useEffect(() => {
        if (get_all_card_details) {
            setCards(get_all_card_details.records)
        }
    }, [get_all_card_details])

    useEffect(() => {
        if (usercards?.length) {
            setCards(usercards)
        }
    }, [usercards])

    useEffect(() => {
        getLocation()
    }, [])

    const handleLocationDialog = () => {
        setLocationDialog(false)
    }
    const handleTermsDialog = () => {
        setTermsDialog(false)
    }

    const handleScheduleRedirect = () => {
        handleRedirectInternal(history, 'dashboard/mybids?s=1&w=1')
    }

    const handleLocationChange = (locationValue) => {
        localStorage.setItem('globalLocation', locationValue)
        setProductState({
            ...productLocalState,
            globalLocation: locationValue,
        })
        setLocationDialog(false)
        if (productLocalState.disableBuynowLocations?.includes(locationValue)) {
            if (
                window.location.pathname.includes('cart') ||
                window.location.pathname.includes('/checkout/buynow')
            ) {
                // handleRedirectInternal(history, '')
                history.replace('/')
            }
        }
        if (window.location.pathname.includes('product-buyer-auction')) {
            // handleRedirectInternal(history, '')
            history.replace('/')
        }
    }

    useEffect(() => {
        if (productLocalState.disableBuynowLocations?.includes(productLocalState.globalLocation)) {
            if (
                window.location.pathname.includes('cart') ||
                window.location.pathname.includes('/checkout/buynow')
            ) {
                handleRedirectInternal(history, '')
            }
        }
    }, [window.location])

    useEffect(() => {
        if (pluginstatus) {
            if (pluginstatus.from === 'request_become_seller_from') {
                if (pluginstatus.status === 'success') {
                    window.open(pluginstatus.message)
                }
            }
            clearpluginresponse()
        }
    }, [pluginstatus])

    const isBidDepotProject = document.querySelector('body').classList.contains('BidAuction')
    const bargainColor = isBargainsAuctionTheme ? '#0d3575' : '#fff'
    return (
        <>
            {isDesktop ? (
                /* DESKTOP NAVIGATION */
                <>
                    <header className="mainHeader noPrint">
                        <div className="customContainer d-flex align-items-center h-100">
                            <div className="headLt d-flex justify-content-start align-items-center">
                                <Logo className="headerLogo" />
                                {!isBidDepotProject ||
                                    (isBargainsAuctionTheme && (
                                        <>
                                            <Button
                                                aria-controls="categoriesBarDrop"
                                                aria-haspopup="true"
                                                className="categoriesButton"
                                                onClick={handleCatMenu}
                                            >
                                                Categories{' '}
                                                <span className="material-icons">expand_more</span>
                                            </Button>
                                            <Popover
                                                id={'categoriesBarDrop'}
                                                open={Boolean(catAnchormenu)}
                                                anchorEl={catAnchormenu}
                                                onClose={handleCatClose}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                            >
                                                <ul className="categoriesDropMenu">
                                                    {filterValues?.map((data, index) => (
                                                        <ListItem button>
                                                            <div
                                                                className="PmCategoryList-root"
                                                                key={index}
                                                                onClick={() => {
                                                                    handleRedirectInternal(
                                                                        history,
                                                                        'search?q=&z=&m=&view=0&cat=' +
                                                                            data.id,
                                                                    )
                                                                }}
                                                            >
                                                                <picture className="PmCategoryImage-root">
                                                                    <img
                                                                        className="PmCategoryImage lazy"
                                                                        src={
                                                                            data.image != 'noimg'
                                                                                ? process.env
                                                                                      .REACT_APP_PRODUCT_IMAGE_URL +
                                                                                  data.image
                                                                                : process.env
                                                                                      .REACT_APP_AUCTION_IMAGE_URL +
                                                                                  global
                                                                                      ?.storeDetails
                                                                                      ?.logo
                                                                        }
                                                                        data-src="image.jpg"
                                                                        alt={data.description}
                                                                    />
                                                                </picture>
                                                                <h4 className="PmCategoryTitle m-0">
                                                                    {data.description}
                                                                </h4>
                                                            </div>
                                                        </ListItem>
                                                    ))}
                                                </ul>
                                            </Popover>
                                            <Button
                                                aria-controls="helpsDrop"
                                                aria-haspopup="true"
                                                className="categoriesButton"
                                                onClick={handleDealsMenu}
                                            >
                                                Help Center{' '}
                                                <span class="material-icons">expand_more</span>
                                            </Button>
                                            <Popover
                                                id={'helpsDrop'}
                                                open={Boolean(dealAnchormenu)}
                                                anchorEl={dealAnchormenu}
                                                onClose={handleDealsClose}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                            >
                                                <ul className="dealsDropMenu">
                                                    <ListItem
                                                        button
                                                        onClick={() =>
                                                            handleRedirectInternal(history, 'faq')
                                                        }
                                                    >
                                                        FAQs
                                                    </ListItem>
                                                    <ListItem
                                                        button
                                                        onClick={() =>
                                                            handleRedirectInternal(
                                                                history,
                                                                'aboutus',
                                                            )
                                                        }
                                                    >
                                                        About Us
                                                    </ListItem>
                                                    <ListItem
                                                        button
                                                        onClick={() =>
                                                            handleRedirectInternal(
                                                                history,
                                                                'contact_us',
                                                            )
                                                        }
                                                    >
                                                        Contact Us
                                                    </ListItem>
                                                </ul>
                                            </Popover>
                                        </>
                                    ))}
                            </div>

                            <div className="headRt d-flex justify-content-between align-items-center w-100">
                                <ul className="hdrRtLt d-flex justify-content-start align-items-center">
                                    {user && user.role == 1 && (
                                        <>
                                            <li className="headerBtmDivider"></li>
                                            <li>
                                                <Button
                                                    aria-controls="simple-menu"
                                                    aria-haspopup="true"
                                                    onClick={handleMenuAuction}
                                                >
                                                    Sell
                                                </Button>

                                                <Popover
                                                    id={'simple-menu'}
                                                    open={Boolean(auctionMenu)}
                                                    anchorEl={auctionMenu}
                                                    onClose={handleClose}
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'right',
                                                    }}
                                                    transformOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    }}
                                                >
                                                    <ul className="headerDropMenu">
                                                        {/* <ListItem
                                                            button
                                                            onClick={() =>
                                                                handleClose(history, `post-auction`)
                                                            }
                                                        >
                                                            Post Auction
                                                        </ListItem> */}

                                                        <ListItem
                                                            button
                                                            onClick={() =>
                                                                handleClose(
                                                                    history,
                                                                    'post-project?type=auction',
                                                                )
                                                            }
                                                        >
                                                            Post Single Lot
                                                        </ListItem>
                                                        <ListItem
                                                            button
                                                            onClick={() =>
                                                                handleClose(
                                                                    history,
                                                                    'post-project?type=buynow',
                                                                )
                                                            }
                                                        >
                                                            Post Buy Now
                                                        </ListItem>
                                                    </ul>
                                                </Popover>
                                            </li>
                                        </>
                                    )}

                                    {/* <Headernavmenu type="desk"></Headernavmenu> */}

                                    <li className="srchLstCntnr">
                                        <HeaderSearch />
                                    </li>
                                </ul>
                                {!isBidDepotProject && (
                                    <div className="lctnFltr primeLoc">
                                        <span className="material-icons lctnIconVw">
                                            location_on
                                        </span>
                                        <div>
                                            <label>You’re Shopping</label>
                                            <Button
                                                className="fltrValue"
                                                onClick={() => setLocationDialog(true)}
                                            >
                                                {productLocalState.globalLocation}{' '}
                                                <span className="material-icons">expand_more</span>
                                            </Button>
                                        </div>
                                    </div>
                                )}
                                <ul className="d-flex justify-content-start align-items-center bargainHeaderSell">
                                    {isAuthenticated ? (
                                        <>
                                            {isBidDepotProject && !isBargainsAuctionTheme ? (
                                                <>
                                                    <li className="headerSellBtn">
                                                        <NavLink
                                                            activeClassName="active"
                                                            to={{
                                                                pathname: '/',
                                                                state: {
                                                                    scrollTo: 'customContainer',
                                                                    triggerScroll: Date.now(),
                                                                },
                                                            }}
                                                        >
                                                            Browse Auctions
                                                        </NavLink>
                                                    </li>
                                                    <li className="headerSellBtn">
                                                        <NavLink
                                                            activeClassName="active"
                                                            to="/how_it_works"
                                                        >
                                                            How It Works
                                                        </NavLink>
                                                    </li>
                                                    <li className="headerSellBtn">
                                                        <NavLink activeClassName="active" to="/faq">
                                                            FAQ
                                                        </NavLink>
                                                    </li>
                                                    <li className="headerSellBtn">
                                                        <NavLink
                                                            activeClassName="active"
                                                            to="/contact_us"
                                                        >
                                                            Contact Us
                                                        </NavLink>
                                                    </li>
                                                    <li className="headerSellBtn">
                                                        <NavLink
                                                            activeClassName="active"
                                                            to="/aboutus"
                                                        >
                                                            About Us
                                                        </NavLink>
                                                    </li>
                                                </>
                                            ) : null}
                                            <li className="headerSellBtn schedulepickupBtn">
                                                <NavLink
                                                    to="#"
                                                    activeClassName="active"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        setOpenMultiplePickup(true)
                                                    }}
                                                >
                                                    Schedule Pickup
                                                </NavLink>
                                            </li>
                                            <li>
                                                <Button
                                                    className=""
                                                    onClick={() =>
                                                        handleRedirectInternal(
                                                            history,
                                                            'dashboard/favorites',
                                                        )
                                                    }
                                                >
                                                    <span
                                                        className="material-icons-round mr-1"
                                                        style={{ color: bargainColor }}
                                                    >
                                                        star_border
                                                    </span>
                                                </Button>
                                            </li>
                                            {/* {user?.role == 0 ? (
                                                <li className="headerSellBtn">
                                                    <NavLink
                                                        activeClassName="active"
                                                        to="/auctions"
                                                    >
                                                        <Button className="">
                                                            <span className="material-icons-round mr-1">
                                                                star_border
                                                            </span>
                                                        </Button>
                                                    </NavLink>
                                                </li>
                                            ) : null} */}
                                            {isBidAuctionDepotTheme && (
                                                <li>
                                                    <Button
                                                        className={
                                                            window.location.pathname.includes(
                                                                '/dashboard/mybids?s=1',
                                                            )
                                                                ? 'active'
                                                                : ''
                                                        }
                                                        onClick={() =>
                                                            handleRedirectInternal(
                                                                history,
                                                                'dashboard/mybids?s=1',
                                                            )
                                                        }
                                                    >
                                                        <CartIcon />
                                                    </Button>
                                                </li>
                                            )}
                                            {productLocalState.disableBuynowLocations?.includes(
                                                productLocalState.globalLocation,
                                            ) || isBidAuctionDepotTheme ? null : (
                                                <li>
                                                    <Button
                                                        className={
                                                            window.location.pathname.includes(
                                                                '/checkout/buynow',
                                                            )
                                                                ? 'active'
                                                                : ''
                                                        }
                                                        onClick={() =>
                                                            handleRedirectInternal(
                                                                history,
                                                                '/checkout/buynow',
                                                            )
                                                        }
                                                    >
                                                        <CartIcon />
                                                    </Button>
                                                </li>
                                            )}
                                            <li>
                                                <Button
                                                    className="headerIcons"
                                                    aria-controls="simple-menu"
                                                    aria-haspopup="true"
                                                    onClick={handleMenu}
                                                >
                                                    <span
                                                        className="material-icons"
                                                        style={{ color: bargainColor }}
                                                    >
                                                        account_circle
                                                    </span>
                                                </Button>

                                                <Popover
                                                    id={'simple-menu'}
                                                    open={Boolean(anchormenu)}
                                                    anchorEl={anchormenu}
                                                    onClose={handleClose}
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'right',
                                                    }}
                                                    transformOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    }}
                                                >
                                                    <ul className="headerDropMenu">
                                                        <ListItem
                                                            button
                                                            onClick={() =>
                                                                handleClose(
                                                                    history,
                                                                    `${
                                                                        user && user.role == 1
                                                                            ? 'dashboard/overview'
                                                                            : 'dashboard/mybids'
                                                                    }`,
                                                                )
                                                            }
                                                        >
                                                            Dashboard
                                                        </ListItem>

                                                        <ListItem
                                                            button
                                                            onClick={() =>
                                                                handleClose(
                                                                    history,
                                                                    'dashboard/profile',
                                                                )
                                                            }
                                                        >
                                                            Profile
                                                        </ListItem>
                                                        <ListItem button onClick={logoutUser}>
                                                            Logout
                                                        </ListItem>
                                                    </ul>
                                                </Popover>
                                            </li>
                                        </>
                                    ) : (
                                        <>
                                            {isBidDepotProject ? (
                                                <>
                                                    {isBargainsAuctionTheme ? null : (
                                                        <>
                                                            <li className="headerSellBtn">
                                                                <NavLink
                                                                    activeClassName="active"
                                                                    to={{
                                                                        pathname: '/',
                                                                        state: {
                                                                            scrollTo:
                                                                                'customContainer',
                                                                        },
                                                                    }}
                                                                >
                                                                    Browse Auctions
                                                                </NavLink>
                                                            </li>
                                                            <li className="headerSellBtn">
                                                                <NavLink
                                                                    activeClassName="active"
                                                                    to="/how_it_works"
                                                                >
                                                                    How It Works
                                                                </NavLink>
                                                            </li>
                                                            <li className="headerSellBtn">
                                                                <NavLink
                                                                    activeClassName="active"
                                                                    to="/faq"
                                                                >
                                                                    FAQ
                                                                </NavLink>
                                                            </li>
                                                            <li className="headerSellBtn">
                                                                <NavLink
                                                                    activeClassName="active"
                                                                    to="/contact_us"
                                                                >
                                                                    Contact Us
                                                                </NavLink>
                                                            </li>
                                                            <li className="headerSellBtn">
                                                                <NavLink
                                                                    activeClassName="active"
                                                                    to="/aboutus"
                                                                >
                                                                    About Us
                                                                </NavLink>
                                                            </li>
                                                        </>
                                                    )}

                                                    {!isBargainsAuctionTheme ? (
                                                        <>
                                                            <li className="headerSellBtn">
                                                                <NavLink
                                                                    activeClassName="active"
                                                                    to="/sign-up"
                                                                >
                                                                    Register
                                                                </NavLink>
                                                            </li>
                                                            <li className="headerSellBtn">
                                                                <NavLink
                                                                    activeClassName="active"
                                                                    to="/login"
                                                                    className="signInButton"
                                                                >
                                                                    Sign in
                                                                </NavLink>
                                                            </li>
                                                        </>
                                                    ) : (
                                                        <>
                                                            {' '}
                                                            <li className="headerSellBtn signInButton">
                                                                <NavLink
                                                                    activeClassName="active"
                                                                    to="/login"
                                                                >
                                                                    Sign in
                                                                </NavLink>{' '}
                                                                /{' '}
                                                                <NavLink
                                                                    activeClassName="active"
                                                                    to="/sign-up"
                                                                >
                                                                    Sign Up
                                                                </NavLink>
                                                            </li>
                                                        </>
                                                    )}
                                                </>
                                            ) : (
                                                <li className="headerSellBtn">
                                                    <NavLink activeClassName="active" to="/login">
                                                        <Button className="lgSgnBtn">
                                                            LOGIN / SIGNUP
                                                        </Button>
                                                    </NavLink>
                                                </li>
                                            )}
                                        </>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </header>
                </>
            ) : (
                <>
                    {/* MOBILE / TAB NAVIGATION */}
                    <header className="row mainHeader mobHeader customContainer noPrint d-flex align-items-center">
                        <div className="headLt d-flex align-items-center col-lg-6 col-md-0 pl-0 headLogoWid">
                            <Logo className="headerLogo" />
                        </div>

                        <div className="col-lg-12 col-md-0 mt-2 px-0 header-search">
                            <div className="srchLstCntnr">
                                <HeaderSearch />
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '5px' }}>
                            <div>
                                {' '}
                                <Button
                                    className="respNavBtn mnLftNav"
                                    onClick={toggleDrawer('right', true)}
                                >
                                    <span className="material-icons" style={{ color: 'white' }}>
                                        menu
                                    </span>
                                </Button>
                            </div>
                        </div>
                    </header>
                    {isAuthenticated ? (
                        <div
                            className={`mblNavFooter ${isAuthenticated ? '' : 'noAuth'}`}
                            style={{ zIndex: '1000' }}
                        >
                            <div
                                className={`ftrNav headCart ${
                                    location.pathname === '/' ? 'active' : ''
                                }`}
                                style={{ flexDirection: 'column' }}
                            >
                                <Button
                                    className="respNavBtn crtIconBtn"
                                    onClick={() => handleRedirectInternal(history, '')}
                                >
                                    <span
                                        class="material-icons-outlined"
                                        style={{ color: '#013748' }}
                                    >
                                        home
                                    </span>
                                </Button>
                                <label>Home</label>
                            </div>
                            <div
                                className={`ftrNav headCart ${
                                    window.location.pathname.includes('favorites') ? 'active' : ''
                                }`}
                                style={{ flexDirection: 'column' }}
                            >
                                <Button
                                    className="respNavBtn crtIconBtn"
                                    onClick={() =>
                                        handleRedirectInternal(history, 'dashboard/favorites')
                                    }
                                >
                                    <span
                                        class="material-icons-outlined"
                                        style={{ color: '#013748' }}
                                    >
                                        grade
                                    </span>
                                </Button>
                                <label>Watchlist</label>
                            </div>
                            <div
                                className={`ftrNav headCart ${
                                    location.pathname === '/dashboard/mybids' &&
                                    !location.search.includes('s=1')
                                        ? 'active'
                                        : ''
                                }`}
                                style={{ flexDirection: 'column' }}
                            >
                                <Button
                                    className="respNavBtn crtIconBtn"
                                    style={{ height: '36px' }}
                                    onClick={() =>
                                        handleRedirectInternal(history, 'dashboard/mybids')
                                    }
                                >
                                    <img src="/assets/images/noun-bid.png" />
                                </Button>
                                <label>Bids</label>
                            </div>

                            <div
                                className={`ftrNav headCart ${
                                    location.pathname === '/dashboard/mybids' &&
                                    location.search.includes('s=1')
                                        ? 'active'
                                        : ''
                                }`}
                                style={{ flexDirection: 'column' }}
                            >
                                <Button
                                    className="respNavBtn crtIconBtn"
                                    onClick={() =>
                                        handleRedirectInternal(history, 'dashboard/mybids?s=1')
                                    }
                                >
                                    <span
                                        class="material-icons-outlined"
                                        style={{ color: '#013748' }}
                                    >
                                        emoji_events
                                    </span>
                                </Button>
                                <label>Wins</label>
                            </div>
                            <div
                                className="ftrNav headCart actnIcon"
                                style={{ flexDirection: 'column' }}
                            >
                                <Button
                                    className="fltrValue"
                                    onClick={() => setLocationDialog(true)}
                                >
                                    <span
                                        className="material-icons lctnIconVw"
                                        style={{ color: '#013748' }}
                                    >
                                        location_on
                                    </span>
                                </Button>
                                <label>Location</label>
                            </div>
                        </div>
                    ) : (
                        <>
                            {location.pathname === '/login' ||
                            location.pathname === '/sign-up' ? null : (
                                <div className={`mblNavFooter ${isAuthenticated ? '' : 'noAuth'}`}>
                                    <PrimaryButton
                                        label="Login"
                                        onClick={() => handleRedirectInternal(history, 'login')}
                                    />
                                    <SecondaryButton
                                        label="Sign Up"
                                        onClick={() => handleRedirectInternal(history, 'sign-up')}
                                    />
                                </div>
                            )}
                        </>
                    )}
                    <React.Fragment>
                        <SwipeableDrawer
                            className="respHeaderSearch"
                            anchor={'top'}
                            open={state['top']}
                            disableBackdropTransition={!iOS}
                            disableDiscovery={iOS}
                            disableSwipeToOpen={false}
                            onClose={toggleDrawer('top', false)}
                            onOpen={toggleDrawer('top', true)}
                        >
                            <HeaderSearch />
                        </SwipeableDrawer>
                    </React.Fragment>

                    <React.Fragment>
                        <SwipeableDrawer
                            className="headerDrawer acntRtDrwr"
                            anchor={'right'}
                            open={state['right']}
                            disableBackdropTransition={!iOS}
                            disableDiscovery={iOS}
                            disableSwipeToOpen={false}
                            onClose={toggleDrawer('right', false)}
                            onOpen={toggleDrawer('right', true)}
                        >
                            <div className="headRt respNav d-flex justify-content-start align-items-center">
                                <div className="naLogoHead d-flex justify-content-between align-items-center">
                                    <Link to="/" className="w-100 text-center">
                                        <img
                                            className="headerLogo"
                                            src={global?.storeDetails?.logoValue}
                                            alt={`${global?.storeDetails?.name} logo`}
                                        />{' '}
                                    </Link>
                                    <Button
                                        className="headDrawerClose"
                                        onClick={toggleDrawer('right', false)}
                                    >
                                        <span className="material-icons">clear</span>
                                    </Button>
                                </div>
                                {isAuthenticated && (
                                    <div className="col-12 mt-2 px-0 scheduleMob">
                                        <Button
                                            aria-controls="categoriesDrop"
                                            aria-haspopup="true"
                                            className="categoriesButton"
                                            onClick={() => setOpenMultiplePickup(true)}
                                        >
                                            Schedule Pickup
                                        </Button>{' '}
                                    </div>
                                )}
                                <div className="col-12 mt-2 px-0 categoriesInMob">
                                    {
                                        <>
                                            <Button
                                                aria-controls="categoriesDrop"
                                                aria-haspopup="true"
                                                className="categoriesButton"
                                                onClick={handleCatMenu}
                                                disabled={viewCategories.length > 0 ? false : true}
                                            >
                                                Categories{' '}
                                                <span class="material-icons">expand_more</span>
                                            </Button>
                                            <Popover
                                                id={'categoriesDrop'}
                                                open={Boolean(catAnchormenu)}
                                                anchorEl={catAnchormenu}
                                                onClose={handleCatCloseWithoutMenu}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                            >
                                                <ul className="categoriesDropMenu">
                                                    {viewCategories?.map((data, index) => (
                                                        <ListItem
                                                            button
                                                            onClick={() => {
                                                                handleCatClose()
                                                                handleRedirectInternal(
                                                                    history,
                                                                    'search?q=&z=&m=&view=0&cat=' +
                                                                        data.cat_id,
                                                                )
                                                            }}
                                                        >
                                                            <div
                                                                className="PmCategoryList-root"
                                                                key={index}
                                                            >
                                                                <h4 className="PmCategoryTitle m-0">
                                                                    {data.cat_name} ({data.catcount}
                                                                    )
                                                                </h4>
                                                            </div>
                                                        </ListItem>
                                                    ))}
                                                </ul>
                                            </Popover>
                                        </>
                                    }
                                </div>
                                <Divider />
                                <ul className="navRespLinks" onClick={toggleDrawer('right', false)}>
                                    {isBidAuctionTheme && !isAuthenticated && (
                                        // <Headernavmenu type="mobile"></Headernavmenu>
                                        <>
                                            <ListItem button>
                                                <NavLink
                                                    activeClassName="active"
                                                    to={{
                                                        pathname: '/',
                                                        state: {
                                                            scrollTo: 'customContainer',
                                                        },
                                                    }}
                                                    exact
                                                >
                                                    <span className="material-icons">
                                                        description
                                                    </span>{' '}
                                                    Browse Auctions
                                                </NavLink>
                                            </ListItem>
                                            <ListItem button>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/search?q=&z=&m=&cat=&view=0&loc=&cond=&edate=&sort=&slimit=50&page=1"
                                                    exact
                                                >
                                                    <span className="material-icons">
                                                        description
                                                    </span>{' '}
                                                    View All Items
                                                </NavLink>
                                            </ListItem>
                                        </>
                                    )}
                                    {isAuthenticated && (
                                        <>
                                            <ListItem button>
                                                <NavLink activeClassName="active" to="/" exact>
                                                    <span className="material-icons">home</span>{' '}
                                                    Home
                                                </NavLink>
                                            </ListItem>
                                            <ListItem button>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/dashboard/mybids"
                                                >
                                                    <span className="material-icons">
                                                        dashboard
                                                    </span>
                                                    Dashboard
                                                </NavLink>
                                            </ListItem>
                                            <hr className="sdBrDvdr" />
                                            <ListItem button>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/dashboard/profile"
                                                >
                                                    <span className="material-icons">person</span>
                                                    My Account
                                                </NavLink>
                                            </ListItem>
                                            {/* <Headernavmenu type="mobile"></Headernavmenu> */}
                                            <ListItem button>
                                                <NavLink
                                                    activeClassName="active"
                                                    to={{
                                                        pathname: '/',
                                                        state: {
                                                            scrollTo: 'customContainer',
                                                        },
                                                    }}
                                                    exact
                                                >
                                                    <span className="material-icons">
                                                        description
                                                    </span>{' '}
                                                    Browse Auctions
                                                </NavLink>
                                            </ListItem>
                                            <ListItem button>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/search?q=&z=&m=&cat=&view=0&loc=&cond=&edate=&sort=&slimit=50&page=1"
                                                    exact
                                                >
                                                    <span className="material-icons">
                                                        description
                                                    </span>{' '}
                                                    View All Items
                                                </NavLink>
                                            </ListItem>
                                            <hr className="sdBrDvdr" />

                                            <h4 className="sdDvdrHdr">Buyer</h4>
                                            <ListItem button>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/dashboard/mybids"
                                                >
                                                    <span className="material-icons">gavel</span>
                                                    My Bids
                                                </NavLink>
                                            </ListItem>

                                            <ListItem button>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/dashboard/favorites"
                                                >
                                                    <span className="material-icons">favorite</span>
                                                    My Watchlist
                                                </NavLink>
                                            </ListItem>

                                            <ListItem button>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/dashboard/savedSearch"
                                                >
                                                    <span className="material-icons">bookmark</span>
                                                    Saved Search
                                                </NavLink>
                                            </ListItem>
                                            <ListItem button>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/dashboard/preference"
                                                >
                                                    <span className="material-icons">
                                                        notifications
                                                    </span>
                                                    Preferences
                                                </NavLink>
                                            </ListItem>

                                            <ListItem button>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/dashboard/cards"
                                                >
                                                    <span className="material-icons">
                                                        credit_card
                                                    </span>
                                                    Saved Cards
                                                </NavLink>
                                            </ListItem>
                                            {global?.pluginConfiguration?.ach_stripe?.enable ==
                                            1 ? (
                                                <ListItem button>
                                                    <NavLink
                                                        to="/dashboard/ach"
                                                        activeClassName="active"
                                                    >
                                                        <span className="material-icons">
                                                            account_balance
                                                        </span>
                                                        Saved Bank Details
                                                    </NavLink>
                                                </ListItem>
                                            ) : null}
                                            <ListItem button>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/dashboard/transactions"
                                                >
                                                    <span className="material-icons">receipt</span>
                                                    Transactions
                                                </NavLink>
                                            </ListItem>
                                            {checkBeachThemeClassName || isBidAuctionTheme ? (
                                                ''
                                            ) : (
                                                <ListItem button>
                                                    <NavLink
                                                        to="/dashboard/message"
                                                        activeClassName="active"
                                                    >
                                                        <span className="material-icons">
                                                            question_answer
                                                        </span>
                                                        Message
                                                    </NavLink>
                                                </ListItem>
                                            )}

                                            {/* {user && user.role != 1 && (
                                                <>
                                                    <hr className="sdBrDvdr mb-0" />
                                                    <ListItem button>
                                                        <NavLink
                                                            activeClassName="active"
                                                            to="/becomeSeller?u=1"
                                                        >
                                                            <span className="material-icons">
                                                                paid
                                                            </span>
                                                            Become a Seller
                                                        </NavLink>
                                                    </ListItem>
                                                </>
                                            )} */}

                                            {user && user.role == 1 && (
                                                <>
                                                    <hr className="sdBrDvdr" />
                                                    <h4 className="sdDvdrHdr">Seller</h4>
                                                    <ListItem button>
                                                        <NavLink
                                                            activeClassName="active"
                                                            to="/sellerdashboard"
                                                        >
                                                            <span className="material-icons">
                                                                store
                                                            </span>
                                                            My Auctions
                                                        </NavLink>
                                                    </ListItem>
                                                    <ListItem button>
                                                        <NavLink
                                                            activeClassName="active"
                                                            to="/dashboard/mylots"
                                                        >
                                                            <span className="material-icons">
                                                                store
                                                            </span>
                                                            My Lots
                                                        </NavLink>
                                                    </ListItem>
                                                    <ListItem button>
                                                        <NavLink
                                                            activeClassName="active"
                                                            to="/dashboard/reports"
                                                        >
                                                            <span className="material-icons">
                                                                description
                                                            </span>
                                                            Reports
                                                        </NavLink>
                                                    </ListItem>
                                                </>
                                            )}

                                            <hr className="sdBrDvdr" />
                                        </>
                                    )}

                                    <h4 className="sdDvdrHdr">More</h4>
                                    {isBargainsAuctionTheme ? null : (
                                        <ListItem button>
                                            <NavLink activeClassName="active" to="/how_it_works">
                                                <span className="material-icons">groups</span>
                                                How It Works
                                            </NavLink>
                                        </ListItem>
                                    )}
                                    <ListItem button>
                                        <NavLink activeClassName="active" to="/aboutus">
                                            <span className="material-icons">quiz</span>
                                            About Us
                                        </NavLink>
                                    </ListItem>
                                    <ListItem button>
                                        <NavLink activeClassName="active" to="/termsOfService">
                                            <span className="material-icons">auto_stories</span>
                                            Terms & Conditions
                                        </NavLink>
                                    </ListItem>
                                    <ListItem button>
                                        <NavLink activeClassName="active" exact to="/contact_us">
                                            <span className="material-icons">contact_support</span>
                                            Contact Us
                                        </NavLink>
                                    </ListItem>
                                    <ListItem button>
                                        <NavLink activeClassName="active" exact to="/faq">
                                            <span className="material-icons">quiz</span>
                                            FAQ
                                        </NavLink>
                                    </ListItem>
                                    <ListItem button>
                                        <NavLink
                                            activeClassName="active"
                                            exact
                                            to="/product_conditions_returns"
                                        >
                                            <span className="material-icons">auto_stories</span>
                                            Product Conditions and Returns
                                        </NavLink>
                                    </ListItem>

                                    {!isAuthenticated ? (
                                        <>
                                            <ListItem button>
                                                <NavLink activeClassName="active" to="/login">
                                                    <span className="material-icons">login</span>
                                                    Login
                                                </NavLink>
                                            </ListItem>
                                        </>
                                    ) : (
                                        <>
                                            <ListItem button onClick={logoutUser}>
                                                <span className="material-icons">
                                                    power_settings_new
                                                </span>
                                                Logout
                                            </ListItem>
                                        </>
                                    )}
                                </ul>
                            </div>
                        </SwipeableDrawer>
                    </React.Fragment>
                    {isAuthenticated && user && user.role != 1 ? (
                        <>
                            {!cards?.length ? (
                                <div className="nocardBanner">
                                    <p
                                        className="m-0"
                                        onClick={() =>
                                            handleRedirectInternal(history, 'dashboard/cards')
                                        }
                                    >
                                        To place a bid or purchase an item, you must have a payment
                                        method connected
                                    </p>
                                </div>
                            ) : (
                                ''
                            )}
                        </>
                    ) : isAuthenticated && user && user.role == 1 ? (
                        <>
                            {global.storeConfigration?.stripe_integration?.value == 1 &&
                            user?.card_profileid == '' ? (
                                <div className="nocardBanner">
                                    <p
                                        className="m-0"
                                        onClick={() =>
                                            handleRedirectInternal(history, 'dashboard/profile')
                                        }
                                    >
                                        Please click here to finalize your seller account setup.
                                    </p>
                                </div>
                            ) : (
                                ''
                            )}
                        </>
                    ) : (
                        ''
                    )}
                </>
            )}
            {isDesktop && (
                <React.Fragment>
                    <SwipeableDrawer
                        className="catgDrawer auctions"
                        anchor={'left'}
                        open={state['left']}
                        disableBackdropTransition={!iOS}
                        disableDiscovery={iOS}
                        disableSwipeToOpen={false}
                        onClose={toggleDrawer('left', false)}
                        onOpen={toggleDrawer('left', true)}
                    >
                        <div className="catgHead">
                            <h3>Auctions</h3>
                            <Button onClick={toggleDrawer('left', false)}>
                                <span className="material-icons">chevron_left</span>
                            </Button>
                        </div>
                        {viewAuction.length ? (
                            <>
                                <ul className="catgLinks" onClick={toggleDrawer('left', false)}>
                                    {viewAuction.map((data, index) => (
                                        <ListItem
                                            button
                                            className="homeCatgInner auctions"
                                            key={index}
                                            onClick={() => handleClick(data.id)}
                                        >
                                            <div className="auctionListInner">
                                                <h5>{data.title}</h5>
                                                {/* <p>Total lots: {data.lotCount}</p> */}
                                            </div>
                                            <Timer
                                                date_added={data.date_added}
                                                date_closed={data.date_closed}
                                                withText={1}
                                                endText={'Time Left'}
                                                startText="Live Auction Starts In"
                                                theme="multiseller"
                                            />
                                        </ListItem>
                                    ))}
                                </ul>
                                <div className="px-3">
                                    <PrimaryButton
                                        className="viewAllAuc"
                                        onClick={() => handleClose(history, 'auctions')}
                                        label="View all auctions"
                                    />
                                </div>
                            </>
                        ) : (
                            <div className="noCatg">
                                <img src="/assets/svg/noProduct.svg" alt="No Categories" />
                                <h6>No Auctions Found</h6>
                            </div>
                        )}
                    </SwipeableDrawer>
                </React.Fragment>
            )}
            {console.log(global?.storeDetails?.text, 'global?.storeDetails?.text')}
            {global?.storeDetails?.text?.length ? (
                <div className="textSliderWrapper py-2">
                    <Swiper
                        navigation={false}
                        spaceBetween={13}
                        grabCursor={true}
                        slidesPerView={1}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        pagination={false}
                        modules={[Autoplay, EffectCoverflow, Navigation, Pagination]}
                        className="mySwiper"
                    >
                        {global?.storeDetails?.text?.map((val) => (
                            <SwiperSlide>
                                <div>
                                    <p className="mb-0">{val}</p>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            ) : null}

            {unpickedItems == true && isAuthenticated ? (
                <div className="auctionHasItems bunnerSchedule noPrint">
                    <img src="/image/pick-up1.png" className="pickupIcon" alt="Pickup Icon" />
                    <h3>
                        Payment Received! - Now it's time to schedule your curbside pickup. Please
                        make an appointment to pick up your orders.{' '}
                        <Button
                            className="scheduleButtn"
                            onClick={() => {
                                setOpenMultiplePickup(true)
                            }}
                        >
                            {' '}
                            Click here to schedule pickup{' '}
                        </Button>{' '}
                    </h3>
                    <Button className="" onClick={handleUnpickedItemsClose}>
                        <span className="material-icons">clear</span>
                    </Button>
                </div>
            ) : userCount.itemunPaidCount ? (
                <div className="auctionHasItems noPrint">
                    <img src="/assets/svg/TrophyIcon.svg" />
                    <h3>
                        Woohoo! You won! We're processing your payment now - once it goes through,
                        you'll be able to schedule your pickup appointment in your dashboard.{' '}
                        {/* <Link to={`/dashboard/mybids?s=1`}>Click here</Link> to make the payment. */}
                    </h3>
                </div>
            ) : null}
            <CustomDialog title={'Become A Seller'} open={open} function={toggleOpen}>
                <BecomeSeller open={open} setOpen={setOpen} />
            </CustomDialog>
            <Popup
                open={openMultiplePickup}
                handleClose={() => setOpenMultiplePickup(false)}
                size="md"
                className="save-search-modal"
                modaltitle={'Needs Pick Up Scheduled'}
            >
                <>
                    <AllProducts
                        page="bidwon"
                        schedule={true}
                        sch_type={1}
                        hideAction={true}
                        hideFeedback={true}
                        selectedAllLots={true}
                        from_page={'header'}
                    />
                </>
            </Popup>
            <Dialog
                className="slctLctnPopup"
                open={locationDialog}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleLocationDialog}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <div className="lctnDialogWrapper">
                    <div className="imgWrpr">
                        <img src="/assets/images/locIcon.png" />
                    </div>
                    <div className="rtInfoWrpr">
                        <h3>Shopping Location</h3>
                        <label>You are currently shopping in</label>
                        <p className="crntLctn">
                            <span className="material-icons">location_on</span>
                            {currentLocation}
                        </p>
                        {productLocalState.globalLocations?.length > 1 ? (
                            <>
                                <h4>Other Location</h4>
                                {productLocalState.globalLocations.map(
                                    (val) =>
                                        productLocalState.globalLocation !== val && (
                                            <Button
                                                className="othLctn"
                                                onClick={() => handleLocationChange(val)}
                                            >
                                                {val}
                                            </Button>
                                        ),
                                )}
                            </>
                        ) : null}
                    </div>
                </div>
            </Dialog>
            <Dialog
                className=""
                open={termsDialog}
                TransitionComponent={Transition}
                onClose={handleTermsDialog}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                disableBackdropClick
            >
                <div className="lctnDialogWrapper termwrap">
                    <div className="rtInfoWrpr termswrapper">
                        <h3>Terms & Conditions</h3>
                        <hr />
                        <p
                            dangerouslySetInnerHTML={{
                                __html: global.storeDetails.terms_condition,
                            }}
                        ></p>
                        <div className="d-flex align-items-center align-items-mob-start">
                            <input
                                type="checkbox"
                                checked={termsCheck}
                                onClick={() => setTermsCheck(!termsCheck)}
                            />
                            <h4>
                                <a href="#">
                                    I Agree To These Terms, Conditions And Bidding Rules.
                                </a>
                            </h4>
                        </div>
                        <PrimaryButton
                            label="Accept and Continue"
                            onClick={() => {
                                termsCheckUpdate()
                                setBtnLoading(true)
                            }}
                            disabled={!termsCheck || btnLoading}
                        />
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default React.memo(Header)
